<template>
  <div class="w-full">
    <div class="m-auto text-base" :style="{ width: '750px' }">
      <!-- 解密方式选择界面 -->
      <div v-if="!showDecryptProcess">
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          CA解密方式选择
        </div>
        <div class="w-full py-6 overflow-hidden" :style="{ width: '750px' }">
          <div class="text-center text-gray-600 mb-6">
            <p class="text-lg font-medium">请选择与加密时相同的方式进行CA解密</p>
          </div>
          <div class="flex flex-col items-center space-y-6">
            <!-- 介质CA -->
            <div 
              class="w-full max-w-md p-6 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition-all duration-200"
              :class="{ 'border-blue-500 bg-blue-50': selectedMethod === 'medium' }"
              @click="selectMethod('medium')"
            >
              <div class="flex items-center">
                <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full">
                  <a-icon type="usb" class="text-blue-600 text-2xl" />
                </div>
                <div class="ml-4">
                  <h3 class="text-lg font-semibold text-gray-800">介质CA解密</h3>
                  <p class="text-gray-600 mt-1">使用USB Key等物理介质进行解密</p>
                </div>
                <div class="ml-auto">
                  <a-radio :checked="selectedMethod === 'medium'" />
                </div>
              </div>
            </div>
            <!-- 标证通扫码 -->
            <div 
              class="w-full max-w-md p-6 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-green-500 hover:bg-green-50 transition-all duration-200"
              :class="{ 'border-green-500 bg-green-50': selectedMethod === 'bzt' }"
              @click="selectMethod('bzt')"
            >
              <div class="flex items-center">
                <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-green-100 rounded-full">
                  <a-icon type="qrcode" class="text-green-600 text-2xl" />
                </div>
                <div class="ml-4">
                  <h3 class="text-lg font-semibold text-gray-800">标证通扫码解密</h3>
                  <p class="text-gray-600 mt-1">使用标证通APP扫描二维码进行解密</p>
                </div>
                <div class="ml-auto">
                  <a-radio :checked="selectedMethod === 'bzt'" />
                </div>
              </div>
            </div>
            <!-- 全国CA互认扫码 -->
            <div 
              class="w-full max-w-md p-6 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-purple-500 hover:bg-purple-50 transition-all duration-200"
              :class="{ 'border-purple-500 bg-purple-50': selectedMethod === 'national' }"
              @click="selectMethod('national')"
            >
              <div class="flex items-center">
                <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full">
                  <a-icon type="scan" class="text-purple-600 text-2xl" />
                </div>
                <div class="ml-4">
                  <h3 class="text-lg font-semibold text-gray-800">全国CA互认扫码解密</h3>
                  <p class="text-gray-600 mt-1">使用全国CA互认平台扫码进行解密</p>
                </div>
                <div class="ml-auto">
                  <a-radio :checked="selectedMethod === 'national'" />
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8 pt-6 border-t border-gray-200">
            <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
              <div class="flex">
                <div class="flex-shrink-0">
                  <a-icon type="info-circle" class="text-yellow-400 text-xl" />
                </div>
                <div class="ml-3">
                  <p class="text-sm text-yellow-700">
                    <strong>重要提示：</strong>请务必选择与您在平台上加密时相同的方式。
                    如果您不确定使用了哪种方式加密，请返回原平台查看或联系平台客服。
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-center mt-10 space-x-4">
            <a-button 
              type="primary" 
              size="large" 
              :disabled="!selectedMethod"
              @click="handleNext"
              class="px-8"
            >
              下一步
            </a-button>
          </div>
        </div>
      </div>
      <!-- 标证通/全国互认扫码解密流程 -->
      <div v-else-if="selectedMethod === 'bzt' || selectedMethod === 'national'">
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          {{ selectedMethod === 'bzt' ? '标证通扫码解密' : '全国CA互认扫码解密' }}
        </div>
        
        <div class="w-full py-6 overflow-hidden" :style="{ width: '750px' }">
          <!-- 二维码解密组件 -->
          <QRCodeDecrypt
            ref="qrDecrypt"
            :encrypted-data="mockEncryptedData"
            :ca-method="selectedMethod"
            :digital-envelope="bidderInfo.digitalenvelope"
            :toubaono="toubaono"
            @decrypt-success="handleDecryptSuccess"
            @go-back="handleGoBack"
          />
        </div>
      </div>
      
      <!-- 介质CA解密流程 -->
      <div v-else-if="selectedMethod === 'medium'">
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          介质CA解密
        </div>
        
        <div class="w-full py-6 overflow-hidden" :style="{ width: '750px' }">
          <!-- 介质CA解密组件 -->
          <MediumCADecrypt
            ref="mediumDecrypt"
            :toubaono="toubaono"
            :encrypted-data="mockEncryptedData"
            :ca-type="104"
            :digital-envelope="bidderInfo.digitalenvelope"
            @decrypt-success="handleDecryptSuccess"
            @go-back="handleGoBack"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCodeDecrypt from '../components/QRCodeDecrypt.vue';
import MediumCADecrypt from '../components/MediumCADecrypt.vue';

export default {
  name: 'Step0',
  components: {
    QRCodeDecrypt,
    MediumCADecrypt
  },
  props: {
    bidderInfo: {
      type: Object,
      default: () => ({})
    },
    toubaono: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedMethod: null, // 'medium', 'bzt', 'national'
      showDecryptProcess: false,  // 显示选择界面/解密界面
      // // Mock加密数据（实际应从接口获取）
      mockEncryptedData: 'MIGBAiEAlGBvqfgoKmiUem7HeCJnUMPIlDR3yv93BHVyIZlGsysCICczsgedVG/mPONefAzcY9R2qhVoIcRQDV32+Vt5nFqcBCCGIodZUwTxIWQzUvnsd50RrSwAeOWCc9PH9VGueN9M5QQYM77CawKPzh4ut8awI2xu9x4aj6wH004r'
    };
  },
  methods: {
    selectMethod(method) {
      this.selectedMethod = method;
    },
    handleNext() {
      if (!this.selectedMethod) {
        this.$message.warning('请选择解密方式');
        return;
      }
      this.showDecryptProcess = true;
    },
    handleDecryptSuccess(data) {
      console.log('解密成功:', data);
      // 通知父组件进入下一步,携带解密数据
      this.$emit('next', { 
        caMethod: data.caMethod || this.selectedMethod,
        decryptedKey: data.decryptedKey,
        caInfo: data.caInfo
      });
    },
    handleGoBack() {
      this.showDecryptProcess = false;
      this.selectedMethod = null;
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
